import getArticleField from './getArticleField';

const getQueryField = (prefix, hasLocalNews) => `${
  getArticleField(prefix, hasLocalNews)}s`;

export default getQueryField;
